import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Menu, Spin, Tooltip } from 'antd'
import { UserOutlined, LaptopOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import axios from '../../utils/AxiosUtil'
import 'antd/dist/antd.css'
import './index.css'
import { menuChange } from '../../reducers/menuReduces'

const { SubMenu } = Menu;

export default function Sidebar(props) {
    let history = useHistory();
    // let path = history.location.pathname;
    const dispatch = useDispatch()
    // let offset = path.lastIndexOf('/');
    // path = path.substr(0, offset);//截取到“localhost.../home”

    const [menuList, setMenuList] = useState([]);
    const [dsk, setDsk] = useState();
    const [dok, setDok] = useState();
    const langValue = useSelector(state => state.langList.value)
    useEffect(() => {
        (async function fn() {
            let { data } = await axios.post('/fund/menu/list', { uid: sessionStorage.getItem('uid') });
            // console.log("siderbar menu axios data:", data, typeof data, "isArray:", Array.isArray(data));
            setMenuList(data.data);
            // 存储表单数据
            // 加入编辑用户数据
            var newData = data.menuData
            newData.push({
                en_menu_name: 'Edit user',
                menu_name: '编辑用户'
            })
            dispatch(menuChange({ value: data.menuData }))
            // console.log('roleid:', data.roleId.roleId);
            // console.log('menu:', data.data);

            let menu;
            //若密码较弱，只显示个人设置
            let pwdIsStrong = sessionStorage.getItem('pwdIsStrong');
            // console.log('sidebar pwdIsStrong:', pwdIsStrong);

            // console.log(data.data);
            if (pwdIsStrong == 0) {
                let ps;
                for (let i = 0; i < data ?.data ?.length; i++) {
                    //个人设置menu
                    if (data.data[i].menu_id == 'H0') {
                        ps = i
                    }
                }
                data.data = [data.data[ps]];
                setMenuList(data.data);
                menu = data.data[0];
                // console.log('0 menu:', menu);

                //若为财务同仁，则先显示票据管理菜单
            } else if (pwdIsStrong == 1 && data ?.roleId ?.roleId == 3) {
                for (let i = 0; i < data ?.data ?.length; i++) {
                    if (data.data[i].menu_id == 'B0') {
                        menu = data.data[i];
                    }
                }
                // console.log('role3 menu:', menu);
                if (!menu) {
                    alert(`财务同仁必须设置“票据管理”模块，请联系财务管理同仁在系统“用户设置”勾选`);
                    return;
                }
                //默认首个菜单
            } else {
                menu = data.data[0];
                // console.log('menu:', menu);
            }

            if (menu) {
                let mpath = "/view" + menu.path;
                if (menu.children) {
                    //含子菜单
                    let path = "/view" + menu.children[0].path;
                    //默认展开
                    //默认选中
                    setDsk([path]);
                    setDok([mpath]);
                    //跳转至默认菜单对应页面
                    history.push(path);
                } else {
                    //不含子菜单
                    setDok([mpath]);
                    //默认选中
                    setDsk([mpath]);
                    history.push(mpath);
                }
            }
        })();
    }, [])


    let getMenu = (menuList) => {
        // console.log("@sidebar $getMenu");
        return menuList.map((menu, mIndex) => {
            let mpath = "/view" + menu.path;
            const { menu_name, en_menu_name } = menu
            let menuName = langValue == 0 ? (menu_name + en_menu_name) : (langValue == 1 ? menu_name : en_menu_name);//一级菜单名称
            let str = ``
            if (langValue == 0) {
                str = (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span>{menu_name}</span>
                        <span>{en_menu_name}</span>
                    </div>
                )
            } else if (langValue == 1) {
                str = (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span>{menu_name}</span>
                    </div>
                )
            } else {
                str = (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span>{en_menu_name}</span>
                    </div>
                )
            }
            //有子菜单的
            if (menu.children) {
                return (
                    <SubMenu icon={<UserOutlined />}
                        className="menu_level_1"
                        key={mpath}
                        title={
                            <Tooltip>
                                {str}
                            </Tooltip>
                        }
                    >
                        {menu.children.map((item, index) => {
                            let path = "/view" + item.path;
                            const ch_menu_name = item.menu_name
                            const ch_en_menu_name = item.en_menu_name
                            let child_menuName = langValue == 0 ? (ch_menu_name + ch_en_menu_name) : (langValue == 1 ? ch_menu_name : ch_en_menu_name)
                            let child_str = ``
                            if (langValue == 0) {
                                child_str = (
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span>{ch_menu_name}</span>
                                        <span>{ch_en_menu_name}</span>
                                    </div>
                                )
                            } else if (langValue == 1) {
                                child_str = (
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span>{ch_menu_name}</span>
                                    </div>
                                )
                            } else {
                                child_str = (
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span>{ch_en_menu_name}</span>
                                    </div>
                                )
                            }
                            return <Menu.Item
                                key={path} className="menu_level_2" id={path}
                                style={{ height: 'auto', minHeight: '40px', lineHeight: 'normal', alignItems: 'baseline', whiteSpace: 'pre-wrap' }}
                                onClick={() => {
                                    // console.log("点击菜单[" + item.menu_name + "]，跳转路径：" + path);
                                    props.setBreadCrumb([menu_name, ch_menu_name]);
                                    history.push(path);
                                }}>{child_str}</Menu.Item>
                        })}

                    </SubMenu>
                );
            } else {
                //仅一级菜单
                return (
                    <Menu.Item
                        key={mpath}
                        icon={<LaptopOutlined />}
                        onClick={() => {
                            // console.log("点击菜单[" + menu.menu_name + "]，跳转路径：" + mpath);
                            props.setBreadCrumb([menu_name]);
                            history.push(mpath);
                        }}
                        style={{ height: 'auto', minHeight: '40px', lineHeight: 'normal', alignItems: 'baseline', whiteSpace: 'pre-wrap' }}
                    >{str} </Menu.Item>
                );
            }
        });
    }


    return (
        <div className="sider-bar-wrapper">
            {dsk && dok ?
                <Menu
                    mode="inline"
                    defaultSelectedKeys={dsk}
                    defaultOpenKeys={dok}
                    // selectedKeys={dsk}
                    // openKeys={dok}
                    style={{ height: '100%', borderRight: 0 }}
                >
                    {getMenu(menuList)}

                </Menu>

                :
                <Spin tip="加载中..." />
            }

        </div>
    )
}
